require('./Foundation/Login/Dialog/_Dialog.js')
require('./Foundation/Login/Dialog/LogInComponent.js')
require('./Foundation/Login/Dialog/EmailSignInComponent.js')
require('./Foundation/Login/Dialog/CreateAccountComponent.js')
require('./Foundation/Login/Dialog/PasswordResetComponent/PasswordResetComponent.js')
require('./Foundation/Login/Dialog/CreateAccountExtrasComponent.js')
require('./Foundation/Login/Dialog/LinkAccountComponent.js')
require('./Foundation/Login/Dialog/FeelingShyComponent.js')
require('./Foundation/Login/Dialog/ThirdPartyAuthenticationShepherd.js')
